export const getUserCountry = async () => await fetch(`https://get.geojs.io/v1/ip/country`)
    .then((response) => response.text())
    .catch((error) => console.log(error));
